import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Message } from '@ok/okd';

import { toLocale } from '@common/i18n';

import { recruitImageUrl } from '../utils';

// Inline validation messages for an upload slot, plus a copy-to-clipboard contact email.
const UploadErrorMessages = ({ messages }) => (
  <div className="recruit-submit__file recruit-submit__error">
    ※
    {messages.map((message, idx) => (
      <span key={idx}>{message}</span>
    ))}
    <span>
      <span>{toLocale('recruit_upload_contact_prefix')}</span>
      <CopyToClipboard
        text="recruit@okj.com"
        onCopy={() => Message.success(toLocale('recruit_copied'))}
      >
        <span style={{ margin: '0 3px' }}>
          <span className="recruit-submit__email">recruit@okj.com</span>
          <img
            className="recruit-submit__error-icon"
            src={recruitImageUrl('copy.svg')}
          />
        </span>
      </CopyToClipboard>
      <span>{toLocale('recruit_upload_contact_suffix')}</span>
    </span>
  </div>
);

export default UploadErrorMessages;
